import { render, staticRenderFns } from "./GerenciamentoPedidos.vue?vue&type=template&id=6aae2594&scoped=true&"
import script from "./GerenciamentoPedidos.vue?vue&type=script&lang=js&"
export * from "./GerenciamentoPedidos.vue?vue&type=script&lang=js&"
import style0 from "./GerenciamentoPedidos.vue?vue&type=style&index=0&id=6aae2594&lang=scss&scoped=true&"
import style1 from "./GerenciamentoPedidos.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aae2594",
  null
  
)

export default component.exports